export default __webpack_public_path__ + "static/media/HindiDiwas3.76078b11.JPG";